export default __webpack_public_path__ + "static/media/HSInfo.339acb96.md";